import { useEffect, useRef, useState } from "react";
import "../css/HeaderSetup.css";
import { pageSizes } from "../constants/_constant";
import CuInput from "../../all-patient/components/CuInput";
import CuDropdown from "../../common_component/component/CuDropdown";
import { ImFolderUpload } from "react-icons/im";
import { calculatePercentage } from "../helpers/_drSetupHelpers";
import { MdPrint } from "react-icons/md";
import ReactToPrint from "react-to-print";
import { useUploadfile } from "../../_helper/actions/mutation/image";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { toast } from "react-toastify";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import CuButton from "../../all-patient/components/CuButton";
import { useNavigate } from "react-router-dom";
import { getImageURL } from "../../_helper/utils/image";
import CuWaterMark from "../../common_component/component/CuWaterMark";
import { INITIAL_CONSULTATION_JSON } from "../../new_consultation/constants/_constant";
import CuToggle from "../../all-patient/components/CuToggle";
// import { useLocation, useNavigate } from "react-router-dom";

const pageSizeOption = [
  { key: "A3", value: "A3", text: "A3" },
  { key: "A4", value: "A4", text: "A4" },
  { key: "A5", value: "A5", text: "A5" },
];

const HeaderSetup = () => {
  const [headerStyle, setHeaderStyle] = useState({
    A3: {
      headerHeight: "3",
      footerHeight: "3",
      pageSize: "A4",
      headerUrl: "",
      footerUrl: "",
      watermarkUrl: "",
      watermarkText: "",
      signatureImg: "",
      signatureText: "",
      signatureHeight: "1",
      signatureWidth: "1",
      printSignature: false,
    },
    A4: {
      headerHeight: "3",
      footerHeight: "3",
      pageSize: "A4",
      headerUrl: "",
      footerUrl: "",
      watermarkUrl: "",
      watermarkText: "",
      signatureImg: "",
      signatureText: "",
      signatureHeight: "1",
      signatureWidth: "1",
      printSignature: false,
    },
    A5: {
      headerHeight: "3",
      footerHeight: "3",
      pageSize: "A4",
      headerUrl: "",
      footerUrl: "",
      watermarkUrl: "",
      watermarkText: "",
      signatureImg: "",
      signatureText: "",
      signatureHeight: "1",
      signatureWidth: "1",
      printSignature: false,
    },
  });

  const [selectedImgs, setSelectedImgs] = useState({
    headerImg: null,
    footerImg: null,
    signatureImg: null,
  });
  const { role_id } = useCurrentRole();
  const headerRef = useRef(null);
  const footerRef = useRef(null);
  // const signatureRef = useRef(null);
  const printContentRef = useRef(null);
  const signatureRef = useRef(null);
  const [doctorSettings] = useAtom(doctorSettingAtom);
  const [clinic] = useAtom(clinicAtom);
  const navigate = useNavigate();
  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const selectedPageSize = searchParams.get("page_size");
  const [selectedPageSize, setSelectedPageSize] = useState("A4");

  const uploadFileMutation = useUploadfile();

  useEffect(() => {
    if (doctorSettings?.header_footer_setup) {
      setHeaderStyle(doctorSettings?.header_footer_setup);
    }
  }, [doctorSettings]);

  // const addQueryParam = (key, value) => {
  //   searchParams.set(key, value);
  //   navigate({
  //     pathname: location.pathname,
  //     search: searchParams.toString(),
  //   });
  // };

  const handleBrowse = (id) => {
    if (id === "signature") {
      signatureRef.current.click();
    } else if (id === "header") {
      headerRef.current.click();
    } else {
      footerRef.current.click();
    }
  };

  const handleFileChange = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (id === "signature") {
          setHeaderStyle((prev) => ({
            ...prev,
            [selectedPageSize]: {
              ...prev[selectedPageSize],
              signatureImg: reader.result,
            },
          }));
          setSelectedImgs((prev) => ({ ...prev, signatureImg: file }));
        } else if (id === "header") {
          setHeaderStyle((prev) => ({
            ...prev,
            [selectedPageSize]: {
              ...prev[selectedPageSize],
              headerUrl: reader.result,
            },
          }));
          setSelectedImgs((prev) => ({ ...prev, headerImg: file }));
        } else {
          setHeaderStyle((prev) => ({
            ...prev,
            [selectedPageSize]: {
              ...prev[selectedPageSize],
              footerUrl: reader.result,
            },
          }));
          setSelectedImgs((prev) => ({ ...prev, footerImg: file }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = (id) => {
    console.log(id);
    if (id === "signature") {
      setHeaderStyle((prev) => ({
        ...prev,
        [selectedPageSize]: {
          ...prev[selectedPageSize],
          signatureImg: "",
        },
      }));
      setSelectedImgs((prev) => ({ ...prev, signatureImg: null }));
    } else if (id === "header") {
      setHeaderStyle((prev) => ({
        ...prev,
        [selectedPageSize]: {
          ...prev[selectedPageSize],
          headerUrl: "",
        },
      }));
      setSelectedImgs((prev) => ({ ...prev, headerImg: null }));
    } else {
      setHeaderStyle((prev) => ({
        ...prev,
        [selectedPageSize]: {
          ...prev[selectedPageSize],
          footerUrl: "",
        },
      }));
      setSelectedImgs((prev) => ({ ...prev, footerImg: null }));
    }
  };

  const updateSettings = useUpdateItem(ApiEndPoint.CLINIC);

  // const handleSaveSettings = () => {
  //   if (!doctorSettings?.id) {
  //     toast.error("doctor setting not exist");
  //     return;
  //   }
  //   const formdata = new FormData();
  //   let flag = false;

  //   if (selectedImgs?.headerImg && selectedImgs?.footerImg) {
  //     formdata.append("files", selectedImgs?.headerImg, "header_img");
  //     formdata.append("files", selectedImgs?.footerImg, "footer_img");
  //     formdata.append("files", selectedImgs?.watermarkImg, "watermark_img");
  //     formdata.append("upload_to", "staff");
  //     formdata.append("staff_id", role_id);
  //     flag = true;
  //   } else if (selectedImgs?.footerImg) {
  //     formdata.append("files", selectedImgs?.footerImg, "footer_img");
  //     formdata.append("upload_to", "staff");
  //     formdata.append("staff_id", role_id);
  //     flag = true;
  //   } else if (selectedImgs?.headerImg) {
  //     formdata.append("files", selectedImgs?.headerImg, "header_img");
  //     formdata.append("upload_to", "staff");
  //     formdata.append("staff_id", role_id);
  //     flag = true;
  //   }

  //   const payload = {
  //     ...headerStyle,
  //   };

  //   if (flag) {
  //     uploadFileMutation.mutate(formdata, {
  //       onSuccess: (data) => {
  //         for (let i of data) {
  //           if (i?.filename?.includes("header_img")) {
  //             payload[selectedPageSize]["headerUrl"] = i?.url;
  //           } else {
  //             payload[selectedPageSize]["footerUrl"] = i?.url;
  //           }
  //         }
  //         updateSettings.mutate(
  //           {
  //             data: {
  //               action: "patchDoctorSetting",
  //               clinic_id: clinic?.id,
  //               backend: "True",
  //               id: doctorSettings?.id,
  //               header_footer_setup: payload,
  //             },
  //           },
  //           {
  //             onSuccess: () => toast.success("Settings updated"),
  //             onError: (err) => toast.err(err.response.data.message),
  //           }
  //         );
  //       },
  //       onError: (err) => toast.err(err.response.data.message),
  //     });
  //   } else {
  //     updateSettings.mutate(
  //       {
  //         data: {
  //           action: "patchDoctorSetting",
  //           clinic_id: clinic?.id,
  //           backend: "True",
  //           id: doctorSettings?.id,
  //           header_footer_setup: payload,
  //         },
  //       },
  //       {
  //         onSuccess: () => toast.success("Settings updated"),
  //         onError: (err) => toast.err(err.response.data.message),
  //       }
  //     );
  //   }
  // };

  const handleSaveSettings = () => {
    if (!doctorSettings?.id) {
      toast.error("Doctor setting not exist");
      return;
    }

    const formdata = new FormData();
    let flag = false;

    // Add header, footer, and signature images to formdata if they exist
    if (selectedImgs?.headerImg) {
      formdata.append("files", selectedImgs?.headerImg, "header_img");
      flag = true;
    }
    if (selectedImgs?.footerImg) {
      formdata.append("files", selectedImgs?.footerImg, "footer_img");
      flag = true;
    }
    if (selectedImgs?.signatureImg) {
      formdata.append("files", selectedImgs?.signatureImg, "signature_img");
      flag = true;
    }

    if (flag) {
      formdata.append("upload_to", "staff");
      formdata.append("staff_id", role_id);
    }

    const payload = {
      ...headerStyle,
    };

    if (flag) {
      // If any file is selected, upload the files
      uploadFileMutation.mutate(formdata, {
        onSuccess: (data) => {
          data.forEach((i) => {
            if (i?.filename?.includes("header_img")) {
              payload[selectedPageSize]["headerUrl"] = i?.url;
            } else if (i?.filename?.includes("footer_img")) {
              payload[selectedPageSize]["footerUrl"] = i?.url;
            } else if (i?.filename?.includes("signature_img")) {
              payload[selectedPageSize]["signatureImg"] = i?.url;
            }
          });
          // After successful file upload, update settings
          updateSettings.mutate(
            {
              data: {
                action: "patchDoctorSetting",
                clinic_id: clinic?.id,
                backend: "True",
                id: doctorSettings?.id,
                header_footer_setup: payload,
              },
            },
            {
              onSuccess: () => toast.success("Settings updated"),
              onError: (err) => toast.error(err.response.data.message),
            }
          );
        },
        onError: (err) => toast.error(err.response.data.message),
      });
    } else {
      // If no file is selected, only update settings
      updateSettings.mutate(
        {
          data: {
            action: "patchDoctorSetting",
            clinic_id: clinic?.id,
            backend: "True",
            id: doctorSettings?.id,
            header_footer_setup: payload,
          },
        },
        {
          onSuccess: () => toast.success("Settings updated"),
          onError: (err) => toast.error(err.response.data.message),
        }
      );
    }
  };

  const handleCancelSettings = () => {
    if (doctorSettings?.header_footer_setup) {
      setHeaderStyle(doctorSettings?.header_footer_setup);
    }
    navigate(-1);
  };

  const handleFormChange = (val, label) => {
    setHeaderStyle((prev) => ({
      ...prev,
      [selectedPageSize]: {
        ...prev[selectedPageSize],
        [label]: val,
      },
    }));
  };

  const bodyHeightInCm =
    Number(pageSizes[selectedPageSize]?.height) -
    (Number(headerStyle[selectedPageSize]?.headerHeight) +
      Number(headerStyle[selectedPageSize]?.footerHeight) +
      Number(headerStyle[selectedPageSize]?.signatureHeight));

  const bodyHeight = calculatePercentage(
    selectedPageSize,
    bodyHeightInCm
  )?.heightPercentage;

  const headerHeight = calculatePercentage(
    selectedPageSize,
    headerStyle[selectedPageSize]?.headerHeight
  )?.heightPercentage;

  const footerHeight = calculatePercentage(
    selectedPageSize,
    headerStyle[selectedPageSize]?.footerHeight
  )?.heightPercentage;

  const signatureHeight = calculatePercentage(
    selectedPageSize,
    headerStyle[selectedPageSize]?.signatureHeight
  )?.heightPercentage;

  const signatureWidth = calculatePercentage(
    selectedPageSize,
    headerStyle[selectedPageSize]?.signatureWidth
  )?.widthPercentage;

  return (
    <div className="cu-header-setup-main">
      <div className="cu-header-setup-left">
        <div className="cu-header-setup-left-input-container">
          <CuInput
            label="Header Height (cm)"
            type="number"
            onChange={(e) => handleFormChange(e.target.value, "headerHeight")}
            value={headerStyle[selectedPageSize]?.headerHeight}
          />
          <CuInput
            label="Footer Height (cm)"
            type="number"
            value={headerStyle[selectedPageSize]?.footerHeight}
            onChange={(e) => handleFormChange(e.target.value, "footerHeight")}
          />
        </div>
        <div className="cu-header-setup-left-input-container">
          <div>
            <label>Page Size</label>
            <CuDropdown
              options={pageSizeOption}
              onChange={(val) => setSelectedPageSize(val)}
              value={selectedPageSize}
            />
          </div>
          <div className="flex flex-col text-[12px]">
            <span>{`Header (${headerStyle[selectedPageSize]?.headerHeight} cm)`}</span>
            <span>{`Body (${bodyHeightInCm} cm)`}</span>
            <span>{`Footer (${headerStyle[selectedPageSize]?.footerHeight} cm)`}</span>
          </div>
        </div>
        <div className="cu-header-setup-left-input-container">
          <div className="w-full">
            <label>Header Image</label>
            <div className="cu-header-setup-left-header-footer-img-sec">
              {!headerStyle[selectedPageSize]?.headerUrl && (
                <ImFolderUpload color="#565656" />
              )}
              {!headerStyle[selectedPageSize]?.headerUrl && (
                <button
                  className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
                  onClick={() => handleBrowse("header")}
                >
                  Browse
                </button>
              )}
              {headerStyle[selectedPageSize]?.headerUrl && (
                <img
                  src={getImageURL(headerStyle[selectedPageSize]?.headerUrl)}
                  alt="preview"
                  className="h-[90%] w-full"
                />
              )}
              <input
                ref={headerRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleFileChange(e, "header")}
              />
            </div>

            <button
              className={
                headerStyle[selectedPageSize]?.headerUrl
                  ? "text-[#FF8484]"
                  : "text-[#FFFFFF]"
              }
              onClick={() => handleRemove("header")}
            >
              Remove
            </button>
          </div>
          <div className="w-full">
            <label>Footer Image</label>
            <div className="cu-header-setup-left-header-footer-img-sec">
              {!headerStyle[selectedPageSize]?.footerUrl && (
                <ImFolderUpload color="#565656" />
              )}
              {!headerStyle[selectedPageSize]?.footerUrl && (
                <button
                  className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
                  onClick={() => handleBrowse("footer")}
                >
                  Browse
                </button>
              )}
              {headerStyle[selectedPageSize]?.footerUrl && (
                <img
                  src={getImageURL(headerStyle[selectedPageSize]?.footerUrl)}
                  alt="preview"
                  className="h-[90%] w-full"
                />
              )}
              <input
                ref={footerRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleFileChange(e, "footer")}
              />
            </div>

            <button
              className={
                headerStyle[selectedPageSize]?.footerUrl
                  ? "text-[#FF8484]"
                  : "text-[#FFFFFF]"
              }
              onClick={() => handleRemove("footer")}
            >
              Remove
            </button>
          </div>
        </div>
        <div className="flex">
          <div className="w-[65%]">
            <div className="flex items-center gap-[50px] pb-1">
              <label>Print Signature</label>
              <CuToggle
                toggle={headerStyle[selectedPageSize]?.printSignature}
                setToggle={(val) => handleFormChange(val, "printSignature")}
                type="setup"
              />
            </div>
            <div className="cu-prescription-setup-left-header-footer-img-sec">
              {!headerStyle[selectedPageSize]?.signatureImg && (
                <ImFolderUpload color="#565656" />
              )}

              {!headerStyle[selectedPageSize]?.signatureImg && (
                <button
                  className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
                  onClick={() => handleBrowse("signature")}
                >
                  Browse
                </button>
              )}

              {headerStyle[selectedPageSize]?.signatureImg && (
                <img
                  src={getImageURL(headerStyle[selectedPageSize]?.signatureImg)}
                  alt="preview"
                  className="h-[90%] w-full"
                />
              )}

              <input
                ref={signatureRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleFileChange(e, "signature")}
              />
            </div>

            <button
              className={
                headerStyle[selectedPageSize]?.signatureImg
                  ? "text-[#FF8484]"
                  : "text-[#FFFFFF]"
              }
              onClick={() => {
                handleRemove("signature");
              }}
            >
              Remove
            </button>
          </div>
          <div className="w-[35%] pl-4">
            <label className="">Signature Text</label>
            <div className="cu-prescription-setup-left-header-footer-img-sec mt-1">
              <textarea
                className="w-full h-full border-none outline-none resize-none"
                value={headerStyle[selectedPageSize]?.signatureText}
                onChange={(e) =>
                  handleFormChange(e.target.value, "signatureText")
                }
              />
            </div>

            <button
              className={"text-[#FFFFFF]"}
              // onClick={() => handleRemove("footer")}
            >
              Remove
            </button>
          </div>
        </div>

        <div className="cu-prescription-setup-left-input-container">
          <CuInput
            label="Signature Height (cm)"
            value={headerStyle[selectedPageSize]?.signatureHeight}
            type={"number"}
            onChange={(e) =>
              handleFormChange(e.target.value, "signatureHeight")
            }
          />
          <CuInput
            label="Signature Width (cm)"
            value={headerStyle[selectedPageSize]?.signatureWidth}
            type={"number"}
            onChange={(e) => handleFormChange(e.target.value, "signatureWidth")}
          />
        </div>
        {/* signature Section */}
        {/* <div className="w-full">
          <label>Watermark Image</label>
          <div className="cu-header-setup-left-header-footer-img-sec">
            {!headerStyle[selectedPageSize]?.watermarkUrl && (
              <ImFolderUpload color="#565656" />
            )}
            {!headerStyle[selectedPageSize]?.watermarkUrl && (
              <button
                className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
                onClick={() => handleBrowse("signature")}
              >
                Browse
              </button>
            )}
            {headerStyle[selectedPageSize]?.watermarkUrl && (
              <img
                src={getImageURL(headerStyle[selectedPageSize]?.watermarkUrl)}
                alt="preview"
                className="h-[90%] w-full"
              />
            )}
            <input
              ref={signatureRef}
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => handleFileChange(e, "signature")}
            />
          </div>

          <button
            className={
              headerStyle[selectedPageSize]?.watermarkUrl
                ? "text-[#FF8484]"
                : "text-[#FFFFFF]"
            }
            onClick={() => handleRemove("signature")}
          >
            Remove
          </button>
        </div> */}

        <div className="cu-header-setup-left-input-container">
          {/* <button
            className="rounded w-[123px] h-11 text-sm border"
            onClick={() => handleCancelSettings()}
          >
            Cancel
          </button>
          <button
            className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
            onClick={() => handleSaveSettings()}
          >
            Save
          </button> */}
          <CuButton
            className="border rounded h-11 w-full"
            onClick={handleCancelSettings}
          >
            Cancel
          </CuButton>
          <CuButton
            isLoading={updateSettings?.isLoading}
            className="bg-[#EBF8EC] h-11 w-full rounded"
            onClick={() => handleSaveSettings()}
          >
            Save
          </CuButton>
          <ReactToPrint
            trigger={() => (
              <MdPrint size={20} className="cursor-pointer w-full" />
            )}
            content={() => printContentRef.current}
            pageStyle={`
            @page {
              size: ${selectedPageSize};
              margin: 0;
            }
            @top-left {
              content: none;
            }
            @top-center {
              content: none;
            }
            @top-right {
              content: none;
            }
            @bottom-left {
              content: none;
            }
            @bottom-center {
              content: none;
            }
            @bottom-right {
              content: none;
            }`}
            onBeforePrint={() => {
              // Apply styles to the container div before printing
              if (printContentRef.current) {
                printContentRef.current.style.width = `${pageSizes[selectedPageSize]?.width}cm`; // Example width
                printContentRef.current.style.height = `${pageSizes[selectedPageSize]?.height}cm`; // Example height
              }
            }}
            onAfterPrint={() => {
              // Reset styles after printing (optional)
              if (printContentRef.current) {
                printContentRef.current.style.width = "";
                printContentRef.current.style.height = "";
              }
            }}
          />
        </div>
      </div>
      <div className="cu-header-setup-right">
        <div className="text-[#000000] text-center">{`Dimensions (${pageSizes[selectedPageSize]?.width} * ${pageSizes[selectedPageSize]?.height} cm)`}</div>
        <div className="cu-header-setup-right-inner" ref={printContentRef}>
          {/* <CuWaterMark
            fontSize="30px"
            rotateAngle="45deg"
            content="My Watermark"
            fontWeight="bold"
            backgroundColor="rgba(255, 255, 255, 0.5)"
            position="middle" // Can be 'top', 'middle', or 'bottom'
            isRepeatable={true}
          > */}
          <div
            style={{ height: `${headerHeight}%` }}
            className={`cu-header-setup-section ${
              headerStyle[selectedPageSize]?.headerUrl
                ? ""
                : "cu-header-setup-section-signature"
            }`}
          >
            {headerStyle[selectedPageSize]?.headerUrl ? (
              <img
                src={getImageURL(headerStyle[selectedPageSize]?.headerUrl)}
                alt="header"
                className="h-full w-full"
              />
            ) : (
              `Header (${headerStyle[selectedPageSize]?.headerHeight}cm)`
            )}
          </div>

          <div
            style={{ height: `${bodyHeight}%` }}
            className="cu-header-setup-section cu-header-setup-section-signature"
          >
            {`Body (${bodyHeightInCm}cm)`}
          </div>
          <div
            className={`cu-prescription-setup-signature-sec ${
              headerStyle[selectedPageSize]?.signatureText ||
              headerStyle[selectedPageSize]?.signatureImg
                ? ""
                : "items-center"
            }`}
            style={{ height: `${signatureHeight}%` }}
          >
            {headerStyle[selectedPageSize]?.printSignature &&
              (headerStyle[selectedPageSize]?.signatureImg ||
                headerStyle[selectedPageSize]?.signatureText) && (
                <div style={{ width: `${signatureWidth}%` }} className="">
                  {headerStyle[selectedPageSize]?.signatureImg && (
                    <img
                      src={getImageURL(
                        headerStyle[selectedPageSize]?.signatureImg
                      )}
                      alt="..."
                    />
                  )}
                  {headerStyle[selectedPageSize]?.signatureText
                    ?.split("\n")
                    .map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                </div>
              )}
            {!headerStyle[selectedPageSize]?.signatureText &&
              !headerStyle[selectedPageSize]?.signatureImg &&
              !headerStyle[selectedPageSize]?.printSignature &&
              `Signature (${headerStyle[selectedPageSize]?.signatureHeight}cm)`}
          </div>
          {footerHeight > 0 && (
            <div
              style={{ height: `${footerHeight}%` }}
              className={`cu-header-setup-section ${
                headerStyle[selectedPageSize]?.footerUrl
                  ? ""
                  : "cu-header-setup-section-signature"
              }`}
            >
              {headerStyle[selectedPageSize]?.footerUrl ? (
                <img
                  src={getImageURL(headerStyle[selectedPageSize]?.footerUrl)}
                  alt="footer"
                  className="h-full w-full"
                />
              ) : (
                `Footer (${headerStyle[selectedPageSize]?.footerHeight}cm)`
              )}
            </div>
          )}
          {/* </CuWaterMark> */}
        </div>
      </div>
    </div>
  );
};

export default HeaderSetup;
